import { ReactComponent as FlagAR } from '../assets/icons/flag_ar.svg';
import { ReactComponent as FlagCL } from '../assets/icons/flag_cl.svg';
import { ReactComponent as FlagCO } from '../assets/icons/flag_co.svg';
import { ReactComponent as FlagMX } from '../assets/icons/flag_mx.svg';
import { ReactComponent as FlagPE } from '../assets/icons/flag_pe.svg';
import { ReactComponent as FlagUY } from '../assets/icons/flag_uy.svg';
import { ReactComponent as PickitUser } from '../assets/icons/pickit-user.svg';
import { ReactComponent as PickerUser } from '../assets/icons/picker-user.svg';
import { ReactComponent as Bell } from '../assets/icons/bell_static.svg';
import { ReactComponent as BellNotif } from '../assets/icons/bell_static_notif.svg';
import { ReactComponent as MarkerDropOff } from '../assets/icons/markerDropOff.svg';
import { ReactComponent as MarkerPikit } from '../assets/icons/markerPickit.svg';
import { ReactComponent as MarkerBoth } from '../assets/icons/markerBoth.svg';
import { ReactComponent as MarkerPoint } from '../assets/icons/markerPoint.svg';

export const icons = {
  'flag-ar': FlagAR,
  'flag-cl': FlagCL,
  'flag-co': FlagCO,
  'flag-mx': FlagMX,
  'flag-pe': FlagPE,
  'flag-uy': FlagUY,
  'pickit-user': PickitUser,
  'picker-user': PickerUser,
  bell: Bell,
  bell_notif: BellNotif,
  'marker-dropoff': MarkerDropOff,
  'marker-pickit': MarkerPikit,
  'marker-both': MarkerBoth,
  'marker-point': MarkerPoint,
};
